/* Orlana – Review schrijven. Vanilla JS, geen dependencies. Productneutrale, stand-alone
   paginasectie die uitsluitend een nieuwe review verstuurt via de bestaande Shopify App Proxy
   (/apps/orlana-reviews/invitation|config|products|submit). Met een geldig ?token= toont de
   pagina de persoonlijke, al-gekozen uitnodiging (zoals voorheen — token blijft de spamcontrole,
   geen Turnstile nodig). Zonder token toont dezelfde pagina/hetzelfde formulier het algemene
   campagneformulier: de bezoeker kiest zelf een product uit de actief gekoppelde producten
   (dezelfde productkeuze-UI die al bestond voor "meerdere producten bij één uitnodiging"), en
   Turnstile is dan wél vereist. Toont geen bestaande reviews. */
(function () {
  'use strict';

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = String(text);
    return node;
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (response) {
      return response.json().then(function (json) {
        return { ok: response.ok, status: response.status, json: json };
      }, function () { return { ok: response.ok, status: response.status, json: null }; });
    });
  }

  function debug(message, err) {
    var role = window.Shopify && Shopify.theme && Shopify.theme.role;
    if (window.console && (role && role !== 'main' || (window.Shopify && Shopify.designMode))) console.warn('[Orlana review-submit] ' + message, err && err.message || '');
  }

  function init(root) {
    if (root.dataset.orlanaReviewSubmitReady) return;
    root.dataset.orlanaReviewSubmitReady = 'true';

    var base = (root.dataset.proxy || '/apps/orlana-reviews').replace(/\/$/, '');
    var token = new URLSearchParams(window.location.search).get('token') || '';

    var q = function (sel) { return root.querySelector(sel); };
    var loading = q('[data-loading]');
    var problem = q('[data-problem]');
    var productBox = q('[data-product-box]');
    var productImage = q('[data-product-image]');
    var productTitleEl = q('[data-product-title]');
    var productChoice = q('[data-product-choice]');
    var productList = q('[data-product-list]');
    var form = q('[data-form]');
    var success = q('[data-success]');

    var isGeneral = !token;
    var rating = 0, started = Date.now(), turnstileToken = null, turnstileFailed = false, submitting = false, config = null, chosenProductId = null, chosenProductTitle = null;
    var turnstileBox = q('[data-turnstile]');
    var submitButton = q('[data-submit]');
    var statusEl = q('[data-status]');
    var loadWatchdog = null;

    function clearLoadWatchdog() {
      if (loadWatchdog) { clearTimeout(loadWatchdog); loadWatchdog = null; }
    }

    // A failed or stalled initial load (blocked request, slow/offline network, a backend that
    // never responds) must never leave the visitor staring at "Formulier wordt geladen…"
    // forever — surface a clear, actionable message with a way to try again instead.
    function showProblem(message, retryable) {
      clearLoadWatchdog();
      loading.hidden = true;
      form.hidden = true;
      productChoice.hidden = true;
      problem.hidden = false;
      problem.textContent = '';
      problem.appendChild(document.createTextNode(message || root.dataset.errorText || ''));
      if (retryable) {
        problem.appendChild(document.createElement('br'));
        var retry = el('button', 'orlana-review-submit__button', 'Opnieuw proberen');
        retry.type = 'button';
        retry.addEventListener('click', function () { window.location.reload(); });
        problem.appendChild(retry);
      }
    }

    function fieldError(name, message) {
      var node = q('[data-error="' + name + '"]');
      if (node) { node.textContent = message || ''; node.hidden = !message; }
      var field = form.querySelector('[name="' + name + '"]');
      if (field && field.type !== 'radio') {
        if (message) field.setAttribute('aria-invalid', 'true'); else field.removeAttribute('aria-invalid');
        if (message && node) { node.id = node.id || ('OrsErr-' + name); field.setAttribute('aria-describedby', node.id); }
      }
    }
    function clearErrors() { ['rating', 'reviewerName', 'reviewerEmail', 'body', 'consent', 'shopifyProductId'].forEach(function (n) { fieldError(n, ''); }); statusEl.hidden = true; statusEl.textContent = ''; }
    function paintStars() {
      Array.prototype.forEach.call(form.querySelectorAll('.orlana-review-submit__star-label'), function (label, index) { label.classList.toggle('is-on', index < rating); });
    }
    function clearOnEdit(event) {
      var name = event.target && event.target.name;
      if (name && name !== 'website') fieldError(name, '');
    }
    form.addEventListener('input', clearOnEdit);
    form.addEventListener('change', function (event) {
      clearOnEdit(event);
      if (event.target.name === 'rating') { rating = parseInt(event.target.value, 10) || 0; paintStars(); }
    });

    function loadTurnstile(siteKey, onError) {
      if (!siteKey || !turnstileBox || turnstileBox.dataset.ready) return;
      turnstileBox.dataset.ready = 'true';
      var done = false;
      function render() { if (done) return; done = true; window.turnstile.render(turnstileBox, { sitekey: siteKey, callback: function (t) { turnstileToken = t; }, 'expired-callback': function () { turnstileToken = null; } }); }
      function fail() { if (done) return; done = true; onError && onError(); }
      if (window.turnstile) return render();
      var timer = setTimeout(fail, 8000);
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = function () { clearTimeout(timer); render(); };
      s.onerror = function () { clearTimeout(timer); fail(); };
      document.head.appendChild(s);
    }

    // Loaded only for the general (no-token) campaign form: a personal invitation token is
    // itself the spam gate (backend turnstileGate() skips Turnstile for it), but anyone can open
    // the general form, so it needs the real check. A failed/blocked load must never leave the
    // submit button silently stuck — show a visible, actionable message instead.
    function maybeLoadTurnstile() {
      if (!isGeneral || !config || !config.turnstileSiteKey || !turnstileBox) return;
      loadTurnstile(config.turnstileSiteKey, function () {
        turnstileFailed = true;
        turnstileBox.textContent = '';
        turnstileBox.appendChild(el('p', 'orlana-review-submit__error', 'Spamcontrole kon niet laden. Vernieuw de pagina om het opnieuw te proberen.'));
      });
    }

    function showFormForProduct(product) {
      clearLoadWatchdog();
      chosenProductId = product.productId;
      chosenProductTitle = product.title;
      productBox.hidden = false;
      productTitleEl.textContent = product.title;
      productImage.hidden = true; // no per-product image available from the invitation/products payload
      form.hidden = false;
    }

    function renderProductChoice(products) {
      clearLoadWatchdog();
      productList.textContent = '';
      products.forEach(function (p, index) {
        var wrap = el('label', 'orlana-review-submit__product-option');
        var input = document.createElement('input');
        input.type = 'radio'; input.name = 'productChoice'; input.value = p.productId; input.required = true;
        if (index === 0) input.checked = false;
        input.addEventListener('change', function () { showFormForProduct(p); });
        wrap.appendChild(input);
        wrap.appendChild(el('span', null, p.title));
        productList.appendChild(wrap);
      });
      productChoice.hidden = false;
      loading.hidden = true;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (submitting) return;
      clearErrors();
      var name = form.elements.reviewerName.value.trim();
      var email = form.elements.reviewerEmail.value.trim();
      var body = form.elements.body.value.trim();
      var problems = [];
      if (!rating) problems.push(['rating', 'Kies 1 tot en met 5 sterren']);
      if (name.length < 2) problems.push(['reviewerName', 'Vul je naam in']);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) problems.push(['reviewerEmail', 'Vul een geldig e-mailadres in']);
      if (body.length < 10) problems.push(['body', 'Schrijf minimaal 10 tekens']);
      if (isGeneral && !chosenProductId) problems.push(['shopifyProductId', 'Kies een product']);
      if (problems.length) {
        problems.forEach(function (p) { fieldError(p[0], p[1]); });
        var target = form.querySelector('[aria-invalid="true"]') || form.querySelector('.orlana-review-submit__star-radio');
        if (target) target.focus();
        return;
      }
      if (isGeneral && config && config.turnstileSiteKey) {
        if (turnstileFailed) { statusEl.textContent = 'Spamcontrole niet beschikbaar. Vernieuw de pagina om het opnieuw te proberen.'; statusEl.hidden = false; return; }
        if (!turnstileToken) { statusEl.textContent = 'Wacht even tot de spamcontrole klaar is.'; statusEl.hidden = false; return; }
      }
      submitting = true;
      submitButton.disabled = true;
      submitButton.textContent = 'Bezig met versturen…';
      form.setAttribute('aria-busy', 'true');
      // No separate consent checkbox: submitting the form under the notice text shown directly
      // above the button is the consent. The backend records this exact version + timestamp
      // against the review (never defaults it, never applies it to any other review) and rejects
      // the submission if the version doesn't match what it currently expects to have been shown.
      var payload = {
        shopifyProductId: chosenProductId,
        rating: rating, reviewerName: name, reviewerEmail: email, title: form.elements.title.value, body: body,
        consentNoticeVersion: submitButton.dataset.consentNoticeVersion || '', consentGivenAt: Date.now(),
        website: form.elements.website.value, startedAt: started,
      };
      if (isGeneral) { payload.general = true; payload.productTitle = chosenProductTitle; payload.turnstileToken = turnstileToken; }
      else { payload.invitationToken = token; }
      fetch(base + '/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (json) { return { ok: response.ok, json: json }; });
      }).then(function (result) {
        if (result.ok) {
          form.hidden = true;
          productChoice.hidden = true;
          success.hidden = false;
          success.focus();
          return;
        }
        var fields = (result.json && result.json.fields) || {};
        var generalMessage = (result.json && result.json.error) || 'Het versturen is niet gelukt. Controleer je gegevens en probeer het opnieuw.';
        Object.keys(fields).forEach(function (k) { fieldError(k, fields[k]); });
        statusEl.textContent = generalMessage;
        statusEl.hidden = false;
        if (window.turnstile && turnstileBox && turnstileBox.dataset.ready) { try { window.turnstile.reset(turnstileBox); } catch (e) {} turnstileToken = null; }
      }).catch(function (err) {
        debug('submit failed', err);
        statusEl.textContent = 'Het versturen is niet gelukt. Controleer je verbinding en probeer het opnieuw.';
        statusEl.hidden = false;
      }).then(function () {
        submitting = false;
        submitButton.disabled = false;
        submitButton.textContent = 'Review versturen';
        form.removeAttribute('aria-busy');
      });
    });

    // Watchdog for the initial load: if nothing resolves within 12s (blocked request, dead
    // network, a backend that never answers), stop waiting and show a retryable error instead
    // of leaving "Formulier wordt geladen…" on screen indefinitely.
    loadWatchdog = setTimeout(function () { showProblem(root.dataset.errorText, true); }, 12000);

    if (token) {
      // Personal invitation: resolve the token to its still-eligible product(s). An invalid,
      // expired or already-used token keeps the existing neutral "not valid" message — never a
      // distinguishing error, never a guessed product.
      getJSON(base + '/config').then(function (result) {
        config = result.ok ? result.json : null;
        if (!config || !config.formEnabled) { showProblem(root.dataset.formDisabledText); return null; }
        return getJSON(base + '/invitation?token=' + encodeURIComponent(token));
      }).then(function (result) {
        if (!result) return; // form disabled — already shown
        loading.hidden = true;
        if (!result.ok || !result.json || result.json.valid !== true || !result.json.products || !result.json.products.length) {
          showProblem(root.dataset.invalidTokenText);
          return;
        }
        var products = result.json.products;
        if (products.length === 1) showFormForProduct(products[0]);
        else renderProductChoice(products);
      }).catch(function (err) {
        debug('invitation request failed', err);
        showProblem(root.dataset.errorText, true);
      });
    } else {
      // No token: general campaign form. The visitor picks the product themselves from the
      // actively-mapped list — reusing the exact same product-choice UI as the "multiple eligible
      // products on one invitation" case above. Never falls back to a default/guessed product.
      getJSON(base + '/config').then(function (result) {
        config = result.ok ? result.json : null;
        if (!config || !config.formEnabled) { showProblem(root.dataset.formDisabledText); return null; }
        return getJSON(base + '/products');
      }).then(function (result) {
        if (!result) return; // form disabled — already shown
        loading.hidden = true;
        if (!result.ok || !result.json || !result.json.products || !result.json.products.length) {
          showProblem(root.dataset.noTokenText);
          return;
        }
        maybeLoadTurnstile();
        var products = result.json.products;
        if (products.length === 1) showFormForProduct(products[0]);
        else renderProductChoice(products);
      }).catch(function (err) {
        debug('products request failed', err);
        showProblem(root.dataset.errorText, true);
      });
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-orlana-review-submit]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
